export default "/images/down-arrow-orange.svg?417be893532f9b67bd48e11ab64115f4";